import React, { createContext, useContext, useState, useEffect } from "react";
import { CONFIG } from "../config";

const TimerContext = createContext(null);

export function formatTime(seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
}

export function TimerProvider({ children }) {
  const [timeLeft, setTimeLeft] = useState(CONFIG.countdownMinutes * 60);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsExpired(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <TimerContext.Provider value={{ timeLeft, isExpired, formattedTime: formatTime(timeLeft) }}>
      {children}
    </TimerContext.Provider>
  );
}

export function useTimer() {
  return useContext(TimerContext);
}
